import { statusTone } from "../lib/constants";

export default function StatusPill({ status, "data-testid": testId }) {
  if (!status) return null;
  const tone = statusTone(status);
  return (
    <span className={`status-pill status-${tone}`} data-testid={testId || `status-${status}`}>
      {status.replace(/_/g, " ")}
    </span>
  );
}
